import { msalApp, GRAPH_REQUESTS, requiresInteraction } from '../../utils/auth/Auth-utils';

export default class AuthService {
    constructor() {
        msalApp.handleRedirectCallback((error, response) => {
            //Function that is called after each callback is
            //successful or failed
        })
    }

    async acquireToken(request, redirect) {
        return msalApp.acquireTokenSilent(request).catch(error => {
            //Call acquireTokenPopup (popup window) in case
            //of acquireTokenSilent failure due to consent
            //or interaction required ONLY

            if(requiresInteraction(error.errorCode)) {
                return redirect
                    ? msalApp.acquireTokenRedirect(request)
                    : msalApp.acquireTokenPopup(request)
            }
        })
    }

    login() {
        return msalApp.loginRedirect(GRAPH_REQUESTS.LOGIN)
    }

    logout() {
        msalApp.logout()
    }

    //Renovar token expired
    async renovar() {
        return msalApp.acquireTokenSilent(GRAPH_REQUESTS.LOGIN)
        .then(response => {
            return response
        })
        .catch(error => {
            console.error("ERROR RENOVAR TOKEN: ", error)
        })
    }
    
}